import { STATE } from "src/common/constants";
import { UserActionI, UserMessageI } from "../reducers/user";
import { UserI } from "src/types/User";
import {
  storeLanguage,
  SupportedLanguage,
} from "src/i18n/languages";
export const STATE_FETCH_DATA = `${STATE}_GET_DATA` as const;
export const STATE_FETCH_INVOKED = `${STATE}_GET_INVOKED` as const;
export const STATE_FETCH_SUCCESS = `${STATE}_GET_SUCCESS` as const;
export const STATE_FETCH_FAILED = `${STATE}_GET_FAILED` as const;
export const TOGGLE_MESSAGE_COLLAPSED_INVOKED =
  `${STATE}_TOGGLE_MESSAGE_COLLAPSED_INVOKED` as const;
export const TOGGLE_MESSAGE_COLLAPSED =
  `${STATE}_TOGGLE_MESSAGE_COLLAPSED` as const;
export const SET_LANGUAGE = `${STATE}_SET_LANGUAGE` as const;

export const fetchState = () => ({ type: STATE_FETCH_DATA });
export const fetchStateInvoked = (): UserActionI => ({
  type: STATE_FETCH_INVOKED,
});
export const fetchStateSuccess = (payload: UserI): UserActionI => ({
  type: STATE_FETCH_SUCCESS,
  payload,
});
export const fetchStateFailed = (error: Error): UserActionI => ({
  type: STATE_FETCH_FAILED,
  error,
});

export const toggleMessageCollapsed = (
  userMessage: UserMessageI
): UserActionI => ({
  type: TOGGLE_MESSAGE_COLLAPSED,
  userMessage,
});

export const toggleMessageCollapsedInvoked = (
  userMessage: UserMessageI
): UserActionI => ({
  type: TOGGLE_MESSAGE_COLLAPSED_INVOKED,
  userMessage,
});

export const setLanguage = (language: SupportedLanguage): UserActionI => {
  storeLanguage(language);
  return {
    type: SET_LANGUAGE,
    language,
  };
};
